<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            :width="width" :height="height"
         viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
        <g>
	<rect x="0" style="opacity: 0" :width="width" :height="height"/>
            <path d="M12,9c1.6,0,3,1.4,3,3s-1.4,3-3,3s-3-1.4-3-3S10.4,9,12,9 M12,7c-2.8,0-5,2.2-5,5s2.2,5,5,5s5-2.2,5-5S14.8,7,12,7L12,7z
		 M2,13h2c0.6,0,1-0.4,1-1s-0.4-1-1-1H2c-0.5,0-1,0.4-1,1S1.5,13,2,13z M20,13h2c0.5,0,1-0.4,1-1s-0.5-1-1-1h-2c-0.5,0-1,0.4-1,1
		S19.5,13,20,13z M11,2v2c0,0.6,0.4,1,1,1s1-0.4,1-1V2c0-0.5-0.4-1-1-1S11,1.5,11,2z M11,20v2c0,0.5,0.4,1,1,1s1-0.5,1-1v-2
		c0-0.5-0.4-1-1-1S11,19.5,11,20z M6,4.6c-0.4-0.4-1-0.4-1.4,0C4.2,5,4.2,5.6,4.6,6L5.6,7C6,7.4,6.7,7.4,7,7s0.4-1,0-1.4L6,4.6z
		 M18.4,17c-0.4-0.4-1-0.4-1.4,0c-0.4,0.4-0.4,1,0,1.4l1.1,1.1c0.4,0.4,1,0.4,1.4,0c0.4-0.4,0.4-1,0-1.4L18.4,17z M19.4,6
		c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0L17,5.6c-0.4,0.4-0.4,1,0,1.4s1,0.4,1.4,0L19.4,6z M7.1,18.4c0.4-0.4,0.4-1,0-1.4
		c-0.4-0.4-1-0.4-1.4,0L4.6,18c-0.4,0.4-0.4,1,0,1.4s1,0.4,1.4,0L7.1,18.4z"
            class="svg-secondary-color"
            />
</g>
</svg>
</template>

<script>
export default {
    name: "lightThemeIcon",
    props: {
        width: {
            type: Number,
            default: 20
        },
        height: {
            type: Number,
            default: 20
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/common/components/svg/shared/lightThemeIcon.vue